export default __webpack_public_path__ + "static/media/garage.d0a1ab34.svg";